import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiPfpMakerConfig } from '@/data/landingConfig/landingAiPfpMakerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiPfpMaker } from './schemaObject';

interface Props {}
const AiPfpMaker: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiPfpMaker} />
			<LandingTemplate
				data={landingAiPfpMakerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelHeadshotGenerator()}
			/>
		</>
	);
};

export default AiPfpMaker;
